module.exports = __webpack_public_path__ + "static/Verlag-BlackItalic.06a2f7e6.otf";


//////////////////
// WEBPACK FOOTER
// ./src/fonts/Verlag-BlackItalic.otf
// module id = 309
// module chunks = 114276838955818